<template>
  <button @click="exportData" class="btn btn-sm btn-info mr-1 mb-1">
    <i class="fa fa-download"></i>
    {{ $t('export') }}
    <b-modal v-model="exporting" :title="$t('exportingData')" @close="close" no-close-on-esc no-close-on-backdrop
             no-enforce-focus ok-only ok-title="Cancel" @ok="close">
      <div class="alert alert-warning">
        <span>{{ $t('exportNotice') }}</span>
      </div>
      <b-progress :max="totalCount">
        <b-progress-bar :value="downloadedCount"
                        :label="`${((downloadedCount / totalCount) * 100).toFixed(0)}%`"></b-progress-bar>
      </b-progress>
    </b-modal>
  </button>
</template>

<script>
import {saveAs} from 'file-saver';
import Excel from 'exceljs';
import moment from 'moment';

export default {
  props: ['filter', 'totalCount'],
  data() {
    return {
      exporting: false,
      cancelRequest: false,
      downloadedCount: 0
    }
  },
  methods: {
    exportData: async function () {
      this.downloadedCount = 0;
      this.exporting = true;
      let workbook = new Excel.Workbook();
      let sheet = workbook.addWorksheet('data');
      this.setupSheet(sheet);

      let response = null;
      let params = Object.assign({}, this.filter);
      params.page = 1;
      params.pageSize = 1000;
      do {
        if (this.cancelRequest) {
          break;
        }
        let result = await this.$service.get('/invoice-info', {
          params: params
        })
        params.page += 1;
        response = result.data;
        response.docs.forEach(item => {
          let row = {
            code: item.code ? item.code : '',
            companyName: item.companyName ? item.companyName : '',
            domain: item.domain ? item.domain : '',
            status: item.manualInvoiceEnabled ? this.$t('manualInvoice') : item.invoiceEnabled ? this.$t('vat') : this.$t('customer'),
            invoiceCustomerName: item.invoiceCustomerName ? item.invoiceCustomerName : '',
            invoiceCompanyName: item.invoiceCompanyName ? item.invoiceCompanyName : '',
            invoiceTaxCode: item.invoiceTaxCode ? item.invoiceTaxCode : '',
            invoiceIdentity: item.invoiceIdentity ? item.invoiceIdentity : '',
            invoiceAddress: item.invoiceAddress ? item.invoiceAddress : '',
            invoiceEmail: item.invoiceEmail ? item.invoiceEmail.replace(/;/g, ', ') : '',
            invoiceStartTime: item.invoiceStartTime ? moment(item.invoiceStartTime).format('DD/MM/YYYY HH:mm:ss') : ''
          }
          sheet.addRow(row);
          this.downloadedCount += 1;
        })
      } while (response && response.hasNextPage);
      if (!this.cancelRequest) {
        workbook.xlsx.writeBuffer({base64: true}).then(data => {
          this.exporting = false;
          saveAs(new Blob([data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}),
              'invoice-info.xlsx');
        }).finally(() => {
          this.cancelRequest = false;
          this.downloadedCount = 0;
        });
      }
    },
    setupSheet: function (sheet) {
      sheet.columns = [
        {header: this.$t('clientCode'), key: 'code', width: 20},
        {header: this.$t('companyName'), key: 'companyName', width: 40},
        {header: 'Domain', key: 'domain', width: 20},
        {header: this.$t('status'), key: 'status', width: 20},
        {header: this.$t('invoiceCustomerName'), key: 'invoiceCustomerName', width: 20},
        {header: this.$t('invoiceCompanyName'), key: 'invoiceCompanyName', width: 20},
        {header: this.$t('invoiceTaxCode'), key: 'invoiceTaxCode', width: 20},
        {header: this.$t('invoiceIdentity'), key: 'invoiceIdentity', width: 20},
        {header: this.$t('invoiceAddress'), key: 'invoiceAddress', width: 20},
        {header: this.$t('invoiceEmail'), key: 'invoiceEmail', width: 20},
        {header: this.$t('invoiceStartTime'), key: 'invoiceStartTime', width: 20}
      ]
    },
    close() {
      this.cancelRequest = true;
    }
  },
  i18n: {
    messages: {
      en: {
        status: "Status",
        companyName: "Company name",
        invoiceCompanyName: "Invoice Company Name",
        invoiceTaxCode: "Invoice Tax Code",
        invoiceIdentity: "Invoice Identity",
        invoiceAddress: "Invoice Address",
        invoiceEmail: "Invoice Email",
        invoiceStartTime: "Invoice Start Time",
        vat: "VAT",
        customer: "Customer",
        clientCode: "Client Code",
        manualInvoice: "Manual Invoice",
        invoiceCustomerName: "Invoice Customer Name"
      },
      vi: {
        status: "Trạng thái",
        companyName: "Tên công ty",
        invoiceCompanyName: "Tên đơn vị",
        invoiceTaxCode: "Mã số thuế",
        invoiceIdentity: "Số CCCD",
        invoiceAddress: "Địa chỉ",
        invoiceEmail: "Email nhận hóa đơn",
        invoiceStartTime: "Thời gian bắt đầu xuất hóa đơn",
        vat: "Xuất hóa đơn VAT",
        customer: "Khách lẻ",
        clientCode: "Mã khách hàng",
        manualInvoice: "Xuất hóa đơn thủ công",
        invoiceCustomerName: "Tên người mua hàng"
      }
    }
  }
}
</script>